import React, { useState } from 'react';
import {
  useAllVendorsQuery,
  useSaveVendorMutation,
  useVendorCategoriesQuery,
} from '@/queries/vendors';
import { FestivalHeader, Loading } from '../controls';
import Portal from '../modal/Portal';
import FilterableTable from '../table';
import { VendorForm } from './';

export function Vendors() {
  const vendorsQ = useAllVendorsQuery();
  const categoriesQ = useVendorCategoriesQuery();
  const saveMutation = useSaveVendorMutation();

  const vendors = vendorsQ.data ?? [];
  const vendorCategories = categoriesQ.data ?? {};
  const loading =
    vendorsQ.isPending ||
    vendorsQ.isFetching ||
    categoriesQ.isPending ||
    categoriesQ.isFetching;

  const [showModal, setShowModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});

  const buildColumnDefinitions = () => {
    var columnDefs = {};
    columnDefs.vendorName = {
      header: 'Vendor Name',
      filterable: true,
      sortable: true,
      showViewLink: false,
      handleClick: true,
    };
    columnDefs.category = {
      header: 'Category',
      filterable: false,
      sortable: false,
    };
    columnDefs.subcategory = {
      header: 'Subcategory',
      filterable: false,
      sortable: false,
    };
    return columnDefs;
  };

  const onFileUpload = (fileInfo) => {
    const { url, filename } = fileInfo;
    setSelectedVendor((prev) => ({
      ...prev,
      photoURL: url,
      vendorPhoto: filename,
    }));
  };

  const onFileDelete = () => {
    setSelectedVendor((prev) => ({
      ...prev,
      photoURL: null,
      vendorPhoto: null,
    }));
  };

  const handleSave = async (vendor) => {
    const updatedVendor = { ...selectedVendor, ...vendor };
    try {
      await saveMutation.mutateAsync(updatedVendor);
      setShowModal(false);
    } catch {
      /* mutation toast */
    }
  };

  const openModal = (vendor) => {
    const next = vendors.find((v) => v.vendorId === vendor.vendorId) || {};
    setSelectedVendor(next);
    setShowModal(true);
  };

  return (
    <>
      <FestivalHeader
        variant="bethere"
        title="My Vendors"
        subtitle="These are vendors you've used before. You can reuse or select them from your list the next time you create an event, or add new ones during event creation."
        showAdd={true}
        addTitle="Add Vendor"
        addAction={() => {
          setSelectedVendor({});
          setShowModal(true);
        }}
      />
      {loading ? (
        <Loading />
      ) : (
        <FilterableTable
          data={vendors}
          tableTitle=""
          columns={buildColumnDefinitions()}
          includeFilter={false}
          editHandler={openModal}
          toggleModal={openModal}
        />
      )}

      <Portal
        header={selectedVendor.vendorName || 'Add New Vendor'}
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <VendorForm
          vendorCategories={vendorCategories}
          vendor={selectedVendor}
          handleSave={handleSave}
          onFileUpload={onFileUpload}
          onFileDelete={onFileDelete}
        />
      </Portal>
    </>
  );
}
